import React from 'react';

function PharmacySelector({ selectedPharmacy, onPharmacyChange }) {
  return (
    <div className="mb-6 rounded-xl border border-slate-100 bg-slate-50/80 p-4">
      <div className="flex items-center gap-4">
        <div className="max-w-xs flex-1">
          <label className="mb-1 block text-sm font-medium text-slate-700">
            Pharmacy <span className="text-red-500">*</span>
          </label>
          <select
            className="input-field"
            value={selectedPharmacy}
            onChange={(e) => onPharmacyChange(e.target.value)}
            required
          >
            <option value="">Select a pharmacy</option>
            <option value="DELHI">Delhi</option>
            <option value="MORADABAD">Moradabad</option>
            <option value="GURGAON">Gurgaon</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default PharmacySelector; 